import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import HealthITContent from '../components/HealthIT/HealthITContent/HealthITContent'
import HealthITHero from '../components/HealthIT/HealthITHero/HealthITHero'

const HealthIT = ({ data }) => {
  const postNode = {
    title: `Health IT - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="health-it" customTitle />
      <Helmet>
        <title>{`Health IT - ${config.siteTitle}`}</title>
      </Helmet>
      <HealthITHero />
      <HealthITContent />
    </Layout>
  )
}

export default HealthIT
